import { render, staticRenderFns } from "./MenusIndex.vue?vue&type=template&id=4f1f99cd&"
import script from "./MenusIndex.vue?vue&type=script&lang=js&"
export * from "./MenusIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports